import {Component, ElementRef, OnDestroy, OnInit} from "@angular/core";
import {FUINavigationService} from "./navigation.service";
import {FUIResponsiveService} from "../page/responsive.service";
import {FUINavigationTree} from "./navigation-trees/navigation-tree/navigation-tree.model";
import {FUINavLayoutService} from "../nav-layout/nav-layout.service";
import {Subscription} from "rxjs";
import {FUIEventsService} from "../events/events.service";

/**
 * Totally encapsulated $navigation component
 * that can be used when no changes are required
 * to the $navigation.
 */
@Component({
    selector: "fui-navigation",
    templateUrl: "./navigation.component.html",
    styleUrls: ["./navigation.component.scss"],
    standalone: false
})
export class FUINavigationComponent implements OnInit, OnDestroy {

    private subscriptions: Subscription = new Subscription();

    public trees: FUINavigationTree[];

    constructor(public navigationService: FUINavigationService,
                private navLayoutService: FUINavLayoutService,
                private eventsService: FUIEventsService,
                private responsiveService: FUIResponsiveService,
                private elementRef: ElementRef) {
    }

    ngOnInit() {
        this.subscriptions.add(this.navigationService.getTrees().subscribe(trees => this.trees = trees));

        /**
         * Reset and performs actions depending on the screen size
         */
        this.subscriptions.add(this.responsiveService.windowWidth$.subscribe(() => this.handleWindowResize()));
        this.subscriptions.add(this.responsiveService.windowHeight$.subscribe(() => this.handleWindowResize()));

        this.subscriptions.add(this.eventsService.$click.subscribe((event: MouseEvent) => {
            if (!this.elementRef.nativeElement.contains(event.target)) {
                this.resetActiveTree();
            }
        }));
    }

    handleWindowResize(): void {
        if (this.navigationService.useMobileNav()) {
            this.navigationService.resetActiveModal();
            this.navigationService.resetActiveTree();
            this.navLayoutService.toggleFrame(false);
        } else {
            this.navigationService.resetActiveModal();
            this.navigationService.resetActiveTree();
        }
    }

    /**
     * Used for when clicking outside of the $navigation
     * to close everything and disable the overlay
     */
    resetActiveTree(): void {
        /**
         * Checking to see how we should handle a tree reset
         * (which is activated by closing and/or clicking outside of the
         * $navigation area. On mobile we don't want to reset the tree
         * level so that when we open/close the menu it is where we left it
         */
        if (!this.navigationService.useMobileNav()) {
            this.navigationService.resetActiveTree();
            this.navigationService.resetActiveModal();
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
